import React from 'react';
import { astralWalletPostMessageToParent } from '../../../../components/PaymentsMethod/AstralWallet/utils/astralWalletPostMessageToParent';
import { FailedStatusWrapper } from '../FailedStatusWrapper/FailedStatusWrapper';
import { useTranslation } from 'mycheck-core';
import { AstralWalletIFrameMessage } from 'plugins/CheckoutPlugin/components/PaymentsMethod/AstralWallet/constants';

export const PaymentFailed = () => {
  const { t } = useTranslation();
  const handleChangePaymentMethodClick = () => {
    astralWalletPostMessageToParent({
      type: AstralWalletIFrameMessage.CHANGE_PAYMENT_METHOD,
    });
  };

  const handleTryAgainPayment = () => {
    astralWalletPostMessageToParent({
      type: AstralWalletIFrameMessage.TRY_AGAIN_PAYMENT,
    });
  };

  return (
    <FailedStatusWrapper
      title={t('astralWallet.paymentFailedTitle')}
      primaryBtnLabel={t('astralWallet.tryAgainLabel')}
      secondaryBtnLabel={t('astralWallet.changePaymentMethodLabel')}
      onPrimaryBtnClick={handleTryAgainPayment}
      onSecondaryBtnClick={handleChangePaymentMethodClick}
    >
      <p>{t('astralWallet.paymentFailedDescription')}</p>
    </FailedStatusWrapper>
  );
};
